import { Box, SvgIconProps, Typography } from '@mui/material';
import { FunctionComponent, PropsWithChildren, SVGProps } from 'react';

interface EmptyStateProps {
  svg:
    | FunctionComponent<PropsWithChildren<SvgIconProps>>
    | FunctionComponent<PropsWithChildren<SVGProps<SVGSVGElement>>>;
  text: string | JSX.Element;
  className?: string;
}

export const EmptyState: FunctionComponent<PropsWithChildren<EmptyStateProps>> = ({ svg: SVG, text, className }) => (
  <Box
    className={className}
    sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', rowGap: 3, maxWidth: '100%', height: '100%' }}
  >
    <SVG sx={{ maxWidth: '100%', height: '100%' }} />
    <Typography align="center" component="span">
      {text}
    </Typography>
  </Box>
);
